import insurancePickerSelector from '../insurancePickerSelector';
import { SCAN_CARD_STATE_KEY } from './scanCardConstants';

export function getScanCardState(state) {
    const pickerState = insurancePickerSelector(state);
    return pickerState[SCAN_CARD_STATE_KEY];
}

export default getScanCardState;
